module.exports = __webpack_public_path__ + "static/media/tn.1e2cfb1b.svg";